import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";
import { SEO } from "../components/seo/SEO";
import { DatenschutzContentDe } from "./legal/DatenschutzContentDe";
import { DatenschutzContentEn } from "./legal/DatenschutzContentEn";

export default function Datenschutz() {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language.startsWith("en");

  return (
    <>
      <SEO
        title={`${isEnglish ? "Privacy Policy" : "Datenschutz"} | Equna`}
        description={t("legal.seo.privacyDescription")}
        canonical="/datenschutz"
      />
      <LegalPageLayout title={isEnglish ? "Privacy Policy" : "Datenschutzerklärung"}>
        {isEnglish ? <DatenschutzContentEn /> : <DatenschutzContentDe />}
      </LegalPageLayout>
    </>
  );
}
